export default __webpack_public_path__ + "static/classic-3b7c01f8bbc177b87069dcba5c3c8a63.png";